<template>
    <div></div>
</template>
<script>
import './iosSelect.css';
import IosSelect from './iosSelect.js'
export default {
    props: {
        isShow: { //是否显示面板
            type: Boolean,
            default: false,
        },
        level: { //层级
            type: Number,
            default: 3
        },
        bindType: { //绑定数据形式: 1:数组(通过parentId关联), 2:方法
            type: Number,
            default: 1
        },
        speciallyType: { //指定类型: 0:无, 1:日期(年月日), 2:日期(年月日时分)
            type: Number,
            default: 0
        },
        initData: { //初始值,多层级的以空格分隔,如'上海市 上海市 静安区'
            type: String,
            default: ""
        },
        iosSelectDataSet: { //数据源
            type: Array
        },
        targetObject: { //目标对象
            type: Object
        },
        headerTitle: { //面板标题
            type: String,
            default: ""
        },
        headerHeight: { //标题栏高度
            type: Number,
            default: 44
        },
        itemHeight: { //选项行高
            type: Number,
            default: 35
        },
        cssUnit: { //元素css尺寸单位，可选项，可选px或者rem
            type: String,
            default: "px"
        },
        addClassName: { //组件额外类名，用于自定义样式，可选项
            type: String,
            default: ""
        },
        sureText: { //设置确定按钮文字，可选项
            type: String,
            default: "确定"
        },
        closeText: { //设置取消按钮文字，可选项
            type: String,
            default: "取消"
        },
        relation: { //联动
            type: Array
        },
        isShowAnimate: { //是否显示入场动画和退场动画
            type: Boolean,
            default: true
        },
    },
	data () {
		return {
		}
    },
    mounted () {
        if(this.isShow){
            this.showSelect();
        }
    },
    watch: {
        isShow(){
            if(this.isShow){
                this.showSelect();
            }
        },
    },
	methods: {
        //地址显示控件点击后触发事件
        showSelect(){
            let self = this;
            //数据源
            let iosSelectData = [];
            if(this.bindType && this.bindType == 2){ //方法
                var yearData = function(callback) {
                    callback(self.formatYear(1900));
                }
                var monthData = function (year, callback) {
                    callback(self.formatMonth());
                };
                var dateData = function (year, month, callback) {
                    if (/^(1|3|5|7|8|10|12)$/.test(month)) {
                        callback(self.formatDate(31));
                    }
                    else if (/^(4|6|9|11)$/.test(month)) {
                        callback(self.formatDate(30));
                    }
                    else if (/^2$/.test(month)) {
                        if (year % 4 === 0 && year % 100 !==0 || year % 400 === 0) {
                            callback(self.formatDate(29));
                        }
                        else {
                            callback(self.formatDate(28));
                        }
                    }
                    else {
                        throw new Error('month is illegal');
                    }
                };
                var hourData = function(one, two, three, callback) {
                    var hours = [];
                    for (var i = 0,len = 24; i < len; i++) {
                        hours.push({
                            id: i,
                            value: i + '时'
                        });
                    }
                    callback(hours);
                };
                var minuteData = function(one, two, three, four, callback) {
                    var minutes = [];
                    for (var i = 0, len = 60; i < len; i++) {
                        minutes.push({
                            id: i,
                            value: i + '分'
                        });
                    }
                    callback(minutes);
                };
                if(this.speciallyType == 1){ //日期 - 年月日
                    iosSelectData = [yearData,monthData,dateData];
                } else if(this.speciallyType == 2){ //日期 - 年月日时分
                    iosSelectData = [yearData,monthData,dateData,hourData,minuteData];
                }
            } else if(this.iosSelectDataSet && this.iosSelectDataSet.length > 0){
                this.iosSelectDataSet.map(arrData => {
                    iosSelectData.push(arrData);
                });
            }
            let options = {
                title: this.headerTitle,
                headerHeight: this.headerHeight,
                itemHeight: this.itemHeight,
                cssUnit: this.cssUnit,
                addClassName: this.addClassName,
                sureText: this.sureText,
                closeText: this.closeText,
                relation: this.relation,
                showAnimate: this.isShowAnimate,
                //选择确定后的回调
                callback: (selectOneObj, selectTwoObj, selectThreeObj,selectFourObj,selectFiveObj,selectSixObj)=> {
                    let selectedValues = [selectOneObj.value];
                    let selectedIds = [selectOneObj.id];
                    if(self.level == 2){
                        selectedValues.push(selectTwoObj.value);
                        selectedIds.push(selectTwoObj.id);
                    } else if(self.level == 3){
                        selectedValues.push(selectTwoObj.value);
                        selectedIds.push(selectTwoObj.id);
                        selectedValues.push(selectThreeObj.value);
                        selectedIds.push(selectThreeObj.id);
                    } else if(self.level == 4){
                        selectedValues.push(selectTwoObj.value);
                        selectedIds.push(selectTwoObj.id);
                        selectedValues.push(selectThreeObj.value);
                        selectedIds.push(selectThreeObj.id);
                        selectedValues.push(selectFourObj.value);
                        selectedIds.push(selectFourObj.id);
                    } else if(self.level == 5){
                        selectedValues.push(selectTwoObj.value);
                        selectedIds.push(selectTwoObj.id);
                        selectedValues.push(selectThreeObj.value);
                        selectedIds.push(selectThreeObj.id);
                        selectedValues.push(selectFourObj.value);
                        selectedIds.push(selectFourObj.id);
                        selectedValues.push(selectFiveObj.value);
                        selectedIds.push(selectFiveObj.id);
                    } else if(self.level == 6){
                        selectedValues.push(selectTwoObj.value);
                        selectedIds.push(selectTwoObj.id);
                        selectedValues.push(selectThreeObj.value);
                        selectedIds.push(selectThreeObj.id);
                        selectedValues.push(selectFourObj.value);
                        selectedIds.push(selectFourObj.id);
                        selectedValues.push(selectFiveObj.value);
                        selectedIds.push(selectFiveObj.id);
                        selectedValues.push(selectSixObj.value);
                        selectedIds.push(selectSixObj.id);
                    }
                    self.$emit("chgIosSelect",selectedValues,selectedIds,self.targetObject);
                    // console.log(selectedValues);
                    // console.log(selectedIds);
                },
                //选择取消后的回调函数
                fallback: () => {
                    self.$emit("closeIosSelect");
                },
                //点击背景层关闭组件时触发的方法
                maskCallback: () => {
                    self.$emit("closeIosSelect");
                },
            };
            //默认选中值
            //自己实现的根据value获取id
            let defaultIds = this.getIdWithValue(this.initData);
            if(self.level == 1){
                options.oneLevelId = defaultIds[0];
            } else if(self.level == 2){
                options.oneLevelId = defaultIds[0];
                options.twoLevelId = defaultIds[1];
            } else if(self.level == 3){
                options.oneLevelId = defaultIds[0];
                options.twoLevelId = defaultIds[1];
                options.threeLevelId = defaultIds[2];
            } else if(self.level == 4){
                options.oneLevelId = defaultIds[0];
                options.twoLevelId = defaultIds[1];
                options.threeLevelId = defaultIds[2];
                options.fourLevelId = defaultIds[3];
            } else if(self.level == 5){
                options.oneLevelId = defaultIds[0];
                options.twoLevelId = defaultIds[1];
                options.threeLevelId = defaultIds[2];
                options.fourLevelId = defaultIds[3];
                options.fiveLevelId = defaultIds[4];
            } else if(self.level == 6){
                options.oneLevelId = defaultIds[0];
                options.twoLevelId = defaultIds[1];
                options.threeLevelId = defaultIds[2];
                options.fourLevelId = defaultIds[3];
                options.fiveLevelId = defaultIds[4];
                options.sixLevelId = defaultIds[5];
            }
            let iosSelect = new IosSelect(self.level,iosSelectData,options);
        }, 
        //根据value获取id，用以给iosSelect设置初始值
        getIdWithValue(paramsValue){
            let self = this;
            let IdArr = [];
            let valueStr = paramsValue ? paramsValue : "";
            let valueArr = valueStr.split(' ');
            if(self.bindType && self.bindType == 2 && self.speciallyType == 1){
                valueArr = valueStr.split('-');
                if(valueArr && valueArr.length>0){
                    IdArr[0] = valueArr[0] ? JSON.parse(JSON.stringify(valueArr[0])) : "";
                    IdArr[1] = valueArr[1] ? JSON.parse(JSON.stringify(valueArr[1])) : "";
                    IdArr[2] = valueArr[2] ? JSON.parse(JSON.stringify(valueArr[2])) : "";
                } else {
                    IdArr[0] = "";
                    IdArr[1] = "";
                    IdArr[2] = "";
                }
                if(IdArr[1] && IdArr[1].length>1){
                    let newMonth = IdArr[1].split("");
                    if(parseInt(newMonth[0]) == 0){
                        IdArr[1] = newMonth[1];
                    }
                }
                if(IdArr[2] && IdArr[2].length>1){
                    let newDate = IdArr[2].split("");
                    if(parseInt(newDate[0]) == 0){
                        IdArr[2] = newDate[1];
                    }
                }
            } else {
                //数据源
                let iosSelectDataSet = [];
                if(this.iosSelectDataSet && this.iosSelectDataSet.length > 0){
                    this.iosSelectDataSet.map(arrData => {
                        iosSelectDataSet.push(arrData);
                    });
                }
                if(self.level == 1){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                } else if(self.level == 2){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                    let id1 = 0;
                    if (valueArr[1]) {
                        for(let i=0; i<iosSelectDataSet[1].length; i++){
                            if (iosSelectDataSet[1][i].value == valueArr[1]) {
                                id1 = iosSelectDataSet[1][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id1);
                } else if(self.level == 3){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                    let id1 = 0;
                    if (valueArr[1]) {
                        for(let i=0; i<iosSelectDataSet[1].length; i++){
                            if (iosSelectDataSet[1][i].value == valueArr[1]) {
                                id1 = iosSelectDataSet[1][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id1);
                    
                    let id2 = 0;
                    if (valueArr[2]) {
                        for(let i=0; i<iosSelectDataSet[2].length; i++){
                            if (iosSelectDataSet[2][i].value == valueArr[2]) {
                                id2 = iosSelectDataSet[2][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id2);
                } else if(self.level == 4){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                    let id1 = 0;
                    if (valueArr[1]) {
                        for(let i=0; i<iosSelectDataSet[1].length; i++){
                            if (iosSelectDataSet[1][i].value == valueArr[1]) {
                                id1 = iosSelectDataSet[1][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id1);
                    
                    let id2 = 0;
                    if (valueArr[2]) {
                        for(let i=0; i<iosSelectDataSet[2].length; i++){
                            if (iosSelectDataSet[2][i].value == valueArr[2]) {
                                id2 = iosSelectDataSet[2][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id2);
                    
                    let id3 = 0;
                    if (valueArr[3]) {
                        for(let i=0; i<iosSelectDataSet[3].length; i++){
                            if (iosSelectDataSet[3][i].value == valueArr[3]) {
                                id3 = iosSelectDataSet[3][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id3);
                } else if(self.level == 5){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                    let id1 = 0;
                    if (valueArr[1]) {
                        for(let i=0; i<iosSelectDataSet[1].length; i++){
                            if (iosSelectDataSet[1][i].value == valueArr[1]) {
                                id1 = iosSelectDataSet[1][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id1);
                    
                    let id2 = 0;
                    if (valueArr[2]) {
                        for(let i=0; i<iosSelectDataSet[2].length; i++){
                            if (iosSelectDataSet[2][i].value == valueArr[2]) {
                                id2 = iosSelectDataSet[2][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id2);
                    
                    let id3 = 0;
                    if (valueArr[3]) {
                        for(let i=0; i<iosSelectDataSet[3].length; i++){
                            if (iosSelectDataSet[3][i].value == valueArr[3]) {
                                id3 = iosSelectDataSet[3][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id3);
                    
                    let id4 = 0;
                    if (valueArr[4]) {
                        for(let i=0; i<iosSelectDataSet[4].length; i++){
                            if (iosSelectDataSet[4][i].value == valueArr[4]) {
                                id4 = iosSelectDataSet[4][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id4);
                } else if(self.level == 6){
                    let id0 = 0;
                    if (valueArr[0]) {
                        for(let i=0; i<iosSelectDataSet[0].length; i++){
                            if (iosSelectDataSet[0][i].value == valueArr[0]) {
                                id0 = iosSelectDataSet[0][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id0);
                    let id1 = 0;
                    if (valueArr[1]) {
                        for(let i=0; i<iosSelectDataSet[1].length; i++){
                            if (iosSelectDataSet[1][i].value == valueArr[1]) {
                                id1 = iosSelectDataSet[1][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id1);
                    
                    let id2 = 0;
                    if (valueArr[2]) {
                        for(let i=0; i<iosSelectDataSet[2].length; i++){
                            if (iosSelectDataSet[2][i].value == valueArr[2]) {
                                id2 = iosSelectDataSet[2][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id2);
                    
                    let id3 = 0;
                    if (valueArr[3]) {
                        for(let i=0; i<iosSelectDataSet[3].length; i++){
                            if (iosSelectDataSet[3][i].value == valueArr[3]) {
                                id3 = iosSelectDataSet[3][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id3);
                    
                    let id4 = 0;
                    if (valueArr[4]) {
                        for(let i=0; i<iosSelectDataSet[4].length; i++){
                            if (iosSelectDataSet[4][i].value == valueArr[4]) {
                                id4 = iosSelectDataSet[4][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id4);
                    
                    let id5 = 0;
                    if (valueArr[5]) {
                        for(let i=0; i<iosSelectDataSet[5].length; i++){
                            if (iosSelectDataSet[5][i].value == valueArr[5]) {
                                id5 = iosSelectDataSet[5][i].id;
                                break;
                            }
                        }
                    }
                    IdArr.push(id5);
                }
            }
            return IdArr;
        },

        //日期初始化
        formatYear(beginYear,endYear) {
            let now = new Date();
            endYear = endYear && endYear>=beginYear ? endYear : now.getFullYear();
            let arr = [];
            for (let i = parseInt(beginYear); i <= endYear; i++) {
                arr.push({
                    id: i + '',
                    value: i + '年'
                });
            }
            return arr;
        },
        formatMonth() {
            let arr = [];
            for (let i = 1; i <= 12; i++) {
                arr.push({
                    id: i + '',
                    value: i + '月'
                });
            }
            return arr;
        },
        formatDate(count) {
            let arr = [];
            for (let i = 1; i <= count; i++) {
                arr.push({
                    id: i + '',
                    value: i + '日'
                });
            }
            return arr;
        },
	}
}
</script>


// WEBPACK FOOTER //
// src/shared/components/iosselect/iosSelect.vue